module.exports = __webpack_public_path__ + "static/media/docbrowser-brochure.cf833609.jpg";